import React, { useState } from 'react';
import ChargesTab from './Charges/ChargesTab';
import ProfitLossTab from './Charges/ProfitLossTab';
import ExchangeRateTab from './Charges/ExchangeRateTab';

const ChargesTabs = () => {
    const [activeTab, setActiveTab] = useState('charges'); // Default to 'charges'

    const handleTabChange = (tabName) => {
        setActiveTab(tabName);
    };

    return (
        <>
            <div className="row-gap-2">
                <ul className="nav nav-pills mb-3 custom-tabs gap-0" id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button
                            className={`nav-link ${activeTab === 'charges' ? 'active' : ''}`}
                            id="Estimates-charges-tab"
                            type="button"
                            role="tab"
                            aria-controls="Estimates-charges-tab-pane"
                            aria-selected={activeTab === 'charges'}
                            onClick={() => handleTabChange('charges')}
                        >
                            Charges
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button
                            className={`nav-link ${activeTab === 'profitLoss' ? 'active' : ''}`}
                            id="Estimates-profit-loss-tab"
                            type="button"
                            role="tab"
                            aria-controls="Estimates-profit-loss-tab-pane"
                            aria-selected={activeTab === 'profitLoss'}
                            onClick={() => handleTabChange('profitLoss')}
                        >
                            Profit & Loss
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button
                            className={`nav-link ${activeTab === 'exchangeRate' ? 'active' : ''}`}
                            id="Estimates-exchange-rates-tab"
                            type="button"
                            role="tab"
                            aria-controls="Estimates-exchange-rates-tab-pane"
                            aria-selected={activeTab === 'exchangeRate'}
                            onClick={() => handleTabChange('exchangeRate')}
                        >
                            Exchange Rate
                        </button>
                    </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                    {activeTab === 'charges' && (
                        <div
                            className="tab-pane fade show active"
                            id="Estimates-charges-tab-pane"
                            role="tabpanel"
                            aria-labelledby="Estimates-charges-tab"
                            tabIndex="0"
                        >
                            <ChargesTab />
                        </div>
                    )}
                    {activeTab === 'profitLoss' && (
                        <div
                            className="tab-pane fade show active"
                            id="Estimates-profit-loss-tab-pane"
                            role="tabpanel"
                            aria-labelledby="Estimates-profit-loss-tab"
                            tabIndex="0"
                        >
                            <ProfitLossTab />
                        </div>
                    )}
                    {activeTab === 'exchangeRate' && (
                        <div
                            className="tab-pane fade show active"
                            id="Estimates-exchange-rates-tab-pane"
                            role="tabpanel"
                            aria-labelledby="Estimates-exchange-rates-tab"
                            tabIndex="0"
                        >
                            <ExchangeRateTab />
                        </div>
                    )}
                </div>
            </div>
            <div className="row justify-content-end mt-3 gap-2">
                <button
                    className="btn btn-primary text-xs w-fit"
                    type="submit"
                    onClick={(e) => {
                        e.preventDefault();
                    }}
                >
                    Save
                </button>
                <button
                    className="btn btn-primary text-xs w-fit"
                    type="submit"
                    onClick={(e) => {
                        e.preventDefault();
                    }}
                >
                    Save & Close
                </button>
                <button
                    className="btn btn-primary text-xs w-fit"
                    type="submit"
                    onClick={(e) => {
                        e.preventDefault();
                    }}
                >
                    Save & New
                </button>
                <button
                    className="btn btn-primary text-xs w-fit"
                    type="submit"
                    onClick={(e) => {
                        e.preventDefault();
                    }}
                >
                    Close
                </button>
            </div>
        </>
    );
};

export default ChargesTabs;
